import React from "react";
import "./StatsCard.css";
import {Card, CardContent} from "@mui/material";

/**
 * Displays a card with heavily accented information and a description to the right of it (used on the home page).
 * @author Alizée Grand
 * @version 1.1
 * @creation 20/06/2022
 * @last_update 11/07/2022
 **/
class StatsCard extends React.Component<{
    /**
     * Number to be emphasised.
     */
    nbToDisplay: number,
    /**
     * Card description.
     */
    content: string
}> {

    render() {

        return (

            <Card className="home-page-stats-card" elevation={10}>
                <CardContent className="home-page-stats-card-content">
                    <span className="home-page-stats-number">
                        {
                            this.props.nbToDisplay
                        }
                    </span>
                    <span className="home-page-stats-content">
                        {
                            this.props.content
                        }
                    </span>
                </CardContent>
            </Card>

        );

    };

}

export default StatsCard;
